import React from 'react'
import { Pill } from '../../../ui'

const PRIORITY_CONFIG = {
  LOW: { label: '↓ low', tone: 'neutral' },
  MEDIUM: { label: '— med', tone: 'info' },
  HIGH: { label: '↑ high', tone: 'danger' },
}

export function PriorityChip({ priority, onCycle, disabled = false }) {
  const isNone = priority === 'NONE' || !priority

  if (isNone) {
    if (disabled) return null
    // Empty/none state has its own visual treatment (dashed border) and no
    // tone — kept inline because it doesn't fit any Pill variant.
    return (
      <button
        type="button"
        onClick={onCycle}
        aria-label="Priority: none. Click to set."
        style={{
          fontSize: 9,
          padding: '1px 6px',
          borderRadius: 'var(--radius-pill)',
          border: '1px dashed var(--border)',
          background: 'transparent',
          color: 'var(--text-secondary)',
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          flexShrink: 0,
          fontFamily: 'inherit',
        }}
      >
        + priority
      </button>
    )
  }

  const config = PRIORITY_CONFIG[priority] ?? PRIORITY_CONFIG.MEDIUM
  return (
    <Pill
      as="button"
      type="button"
      tone={config.tone}
      onClick={disabled ? undefined : onCycle}
      disabled={disabled}
      aria-disabled={disabled || undefined}
      aria-label={`Priority: ${priority.toLowerCase()}.${disabled ? '' : ' Click to cycle.'}`}
      style={{ fontSize: 9, padding: '1px 6px', flexShrink: 0 }}
    >
      {config.label}
    </Pill>
  )
}
